export const ERROR_MESSAGES = {
  FILE_TYPE: 'Please check file type',
  IMAGE_SIZE: 'New image for the banner ad must be the same size',
  FILE_SIZE: 'This image is too big',
};
